import get from 'lodash/get'
import has from 'lodash/has'
import set from 'lodash/set'
import unset from 'lodash/unset'

import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 * Run the migration if version is less than the config.
 *
 * Upgrade notes:
 *
 * Bring 'transformer', 'exclude', 'include', 'id' and 'label' to same level as GeoJSON layers:
 * - Migrate 'tranformer' from layer to layer.config
 * - Migrate 'exlude' and 'include' from layer to layer.config.spatial
 * - Migrate 'id' and 'label' from layer.config to layer.config.spatial
 *
 * @param {Object} config
 */
export default function (config) {
  const MIGRATION_TO_VERSION = 5

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    const layers = get(config, 'layers', [])
    for (const layer of layers) {
      // Migrate layer.transformer to layer.config.transformer
      const hasTransformerInRoot = has(layer, 'transformer')
      const hasTransformerInConfig = has(layer, 'config.transformer')
      if (hasTransformerInRoot && !hasTransformerInConfig) {
        const transformer = get(layer, 'transformer')
        console.log('M5 migrate transformer', layer.title, transformer, layer)
        set(layer, 'config.transformer', transformer)
        unset(layer, 'transformer')
      }

      // Migrate layer.exclude to layer.config.spatial.exclude
      const hasExcludeInRoot = has(layer, 'exclude')
      const hasExcludeInConfigSpatial = has(layer, 'config.spatial.exclude')
      if (hasExcludeInRoot && !hasExcludeInConfigSpatial) {
        const exclude = get(layer, 'exclude')
        console.log('M5 migrate exclude', layer.title, exclude, layer)
        set(layer, 'config.spatial.exclude', exclude)
        unset(layer, 'exclude')
      }

      // Migrate layer.include to layer.config.spatial.include
      const hasIncludeInRoot = has(layer, 'include')
      const hasIncludeInConfigSpatial = has(layer, 'config.spatial.include')
      if (hasIncludeInRoot && !hasIncludeInConfigSpatial) {
        const include = get(layer, 'include')
        console.log('M5 migrate include', layer.title, include, layer)
        set(layer, 'config.spatial.include', include)
        unset(layer, 'include')
      }

      // Migrate layer.config.id to layer.config.spatial.id
      const hasIdInConfig = has(layer, 'config.id')
      const hasIdInConfigSpatial = has(layer, 'config.spatial.id')
      if (hasIdInConfig && !hasIdInConfigSpatial) {
        const id = get(layer, 'config.id')
        console.log('M5 migrate id', layer.title, id, layer)
        set(layer, 'config.spatial.id', id)
        unset(layer, 'config.id')
      }

      // Migrate layer.config.label to layer.config.spatial.label
      const hasLabelInConfig = has(layer, 'config.label')
      const hasLabelInConfigSpatial = has(layer, 'config.spatial.label')
      if (hasLabelInConfig && !hasLabelInConfigSpatial) {
        const label = get(layer, 'config.label')
        console.log('M5 migrate label', layer.title, label, layer)
        set(layer, 'config.spatial.label', label)
        unset(layer, 'config.label')
      }
    }

    UpdateVersion(config, MIGRATION_TO_VERSION)
  }

  return config
}
